import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { axiosInstance } from "../../../utils/client";

type NewsLetterItem = {
  userMail: string;
  userId: number;
  businessLocationId: number;
};

type NewsLetterState = {
  subscriptions: NewsLetterItem[];
  isLoading: boolean;
  error: string | false;
};

const initialState: NewsLetterState = {
  subscriptions: [],
  isLoading: false,
  error: false,
};

const newsLetterSlice = createSlice({
  name: "newsLetter",
  initialState,
  reducers: {
    addSubscription: (state, action) => {
      state.subscriptions.push(action.payload);
    },
    setSubscriptions: (state, action) => {
      state.subscriptions = action.payload;
    },
    setNewsLetterLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setNewsLetterError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  addSubscription,
  setSubscriptions,
  setNewsLetterLoading,
  setNewsLetterError,
} = newsLetterSlice.actions;

export default newsLetterSlice.reducer;

// ----------------------------------------------------------------------//

export function saveNewsLetter(userMail: string) {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch(setNewsLetterLoading(true));

      const { selectedBusinessLocation } = getState().businessLocation;

      if (!selectedBusinessLocation?.id) {
        throw new Error("Missing  business location information.");
      }

      const data = {
        userMail,
        businessLocationId: selectedBusinessLocation.id,
      };

      const response = await axiosInstance.post("/newsLetter", data);

      if (response?.data?.success) {
        toast.success(response.data.message);
        dispatch(addSubscription(data));
      } else {
        toast.error(
          response?.data?.message || "Failed to subscribe to newsletter."
        );
      }

      return response.data;
    } catch (error) {
      console.error("Error saving newsletter subscription:", error);
      toast.error("Failed to subscribe to newsletter.");
      dispatch(setNewsLetterError("Failed to subscribe to newsletter."));
    }
  };
}
